var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01929 12.2798L19.0001 20.3706L32.8859 12.3272",
    stroke: "#3A4563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 34.7158V20.355",
    stroke: "#3A4563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7225 4.4265L7.26748 9.12905C5.35165 10.1899 3.78418 12.8499 3.78418 15.0349V23.9807C3.78418 26.1657 5.35165 28.8257 7.26748 29.8865L15.7225 34.5891C17.5275 35.5866 20.4883 35.5866 22.2933 34.5891L30.7483 29.8865C32.6642 28.8257 34.2316 26.1657 34.2316 23.9807V15.0349C34.2316 12.8499 32.6642 10.1899 30.7483 9.12905L22.2933 4.4265C20.4725 3.41317 17.5275 3.41317 15.7225 4.4265Z",
    stroke: "#3A4563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 21.4634V15.6684L11.8909 6.9917",
    stroke: "#3A4563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "6bc8dfa252d00fd689117ab015c2d89d.svg";
export { ForwardRef as ReactComponent };